import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class CalendarSetupService {
  environment = EnvironmentService.environment;

  constructor(private http: HttpClient) { }

  GetCalendarSetupDetail() {
    return this.http.get(`${this.environment.HierarchyManager}/getcalendarsetup`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetCalendarView(body: any) {
    return this.http.post(`${this.environment.HierarchyManager}/getcalendarview`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateCalendar(body: any) {
    return this.http.post(`${this.environment.HierarchyManager}/updatecalendar`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AddCalendar(body: any) {
    return this.http.post(`${this.environment.HierarchyManager}/addcalendar`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

}
